import { Splide } from "@splidejs/splide";

const carousel = () => {
  const targetElms = document.getElementsByClassName('js-FvSlider');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 1000;
    let options = {
      type: "fade",
      rewind: true,
      speed: speed,
      interval: 3000,
      perPage: 1,
      arrows: true,
      pagination: true,
      pauseOnHover: false, // ホバーしても停止しない
      pauseOnFocus: false, // フォーカスしても停止しない
      focus: 'center',
      // autoplay: true,
      reducedMotion: {
        speed: speed,
        interval: 3000,
        autoplay: true,
        pauseOnHover: false, // ホバーしても停止しない
        pauseOnFocus: false, // フォーカスしても停止しない
      }
    };

    // data属性でカスタマイズ
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reducedMotion.speed = parseInt(targetElm.dataset.speed);
      options.reducedMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    if(targetElm.dataset.perpage) {
      options.perPage = parseInt(targetElm.dataset.perpage);
    }

    const splideInstance = new Splide(targetElm, options);

    // アクティブスライドに応じてクラスをトグル
    const setSlideClass = (index) => {
      targetElm.classList.forEach(cls => {
        if (/^--slide\d+$/.test(cls)) targetElm.classList.remove(cls);
      });
      targetElm.classList.add(`--slide${String(index + 1).padStart(2, '0')}`);
    };

    splideInstance.on('mounted', () => setSlideClass(splideInstance.index));
    splideInstance.on('moved', (newIndex) => setSlideClass(newIndex));

    splideInstance.mount();
  }
};

const init = () => {
  carousel();
};

export default init;